import React from "react";
import styled from "styled-components";
import Typography from "../../../../../components/typography";
import { Colors } from "../../../../../utils/colors";
import RatedTubeImg from "../../../../../images/png/special-features-images/rated-tube.png";
import CoverSongImg from "../../../../../images/png/special-features-images/cover-song.png";
import { FeatureData } from "./feature-data";
import { useNavigate } from "react-router-dom";

const OverviewSpecialFeatures = () => {
  const navigate = useNavigate();
  return (
    <Container>
      <Typography mb="1.4" weight="medium" size="2xl">
        Special Features
      </Typography>
      <GridBox>
        {FeatureData.map(({ bg, icon, title, description, link, img }, i) => {
          return (
            <Feature key={i}>
              <FeatureIconBox bg={bg}>
                <Icon>{icon}</Icon>
              </FeatureIconBox>
              <Typography
                size="2xl"
                weight="bold"
                mb="0.8"
                m_size="3xl"
                color={Colors.grey300}
              >
                {title}
              </Typography>
              <Typography color={Colors.grey400} mb="1.6" m_size="xl">
                {description}
              </Typography>
              <ExploreButton onClick={() => navigate(link)}>
                <Typography mr="0.4">Explore</Typography>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M6 4.6665L10 7.99984L6 11.6665"
                    stroke="#F5F5F5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </ExploreButton>
              <FeatureImage src={img} alt={title} />
            </Feature>
          );
        })}
      </GridBox>
    </Container>
  );
};

export default OverviewSpecialFeatures;

const Container = styled.div`
  margin-bottom: 3.2rem;
`;

const GridBox = styled.div`
  display: grid;
  grid-template-columns: 32% 32% 32%;
  grid-row-gap: 1.6rem;
  justify-content: space-between;

  @media only screen and (max-width: 769px) {
    grid-template-columns: 100%;
  }
`;

const Feature = styled.div`
  width: 100%;
  padding: 1.6rem;
  height: 100%;
  background-color: ${Colors.grey700};
  border-radius: 0.8rem;
  overflow: hidden;
  position: relative;
  @media only screen and (max-width: 769px) {
    height: unset;
    padding: 2.4rem 1.2rem;
  }
`;

const FeatureIconBox = styled.div<{ bg: string }>`
  width: 4.8rem;
  height: 4.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.4rem;
  background-color: ${(props) => props.bg};
  margin-bottom: 2.4rem;
`;

const Icon = styled.div`
  width: 2.4rem;
`;

const ExploreButton = styled.div`
  padding: 0.6rem 1.2rem;
  border-radius: 2.8rem;
  border: 0.5px solid ${Colors.white300};
  color: ${Colors.white300};
  background: rgba(255, 255, 255, 0.1);
  width: fit-content;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.1s ease-in-out;
  margin-bottom: 12.1rem;
  position: relative;
  z-index: 2;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: 50px;
    color: ${Colors.white100};
  }
`;

const FeatureImage = styled.img`
  position: absolute;
  right: 0;
  bottom: 0;
`;
